export default "__VITE_ASSET__dueo9Wqt__"